import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Spin } from "antd";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { PluginUpdateForm } from "./form/form.js";
import { PluginUpdateLicenseList } from "./licenseList.js";
import { useStores } from "../../store/stores.js";
import { __, _i } from "../../utils/i18n.js";
const PluginUpdateErrorNotice = observer(({ slug })=>{
    const error = useStores().pluginUpdateStore.pluginUpdateFetchErrors.get(slug);
    const errorMessage = error?.responseJSON?.message;
    return /*#__PURE__*/ _jsx("div", {
        className: "notice notice-error inline below-h2 notice-alt",
        style: {
            margin: "20px 0"
        },
        children: /*#__PURE__*/ _jsx("p", {
            children: _i(__("Something has gone wrong%s. It could be that you have configured your WordPress instance in such a way that you have blocked the WordPress REST API. Find out how to deal with this {{a}}here{{/a}}.", errorMessage ? ` (${errorMessage})` : ""), {
                a: /*#__PURE__*/ _jsx("a", {
                    href: __("https://devowl.io/knowledge-base/wordpress-rest-api-does-not-respond/"),
                    target: "_blank",
                    rel: "noreferrer"
                })
            })
        })
    });
});
/**
 * Embed the license form and list of activated licenses into your app.
 * Please consider, that this embed does not provide any buttons, please provide
 * them yourself with `<button form="license-form-$slug"`>
 */ const PluginUpdateEmbed = observer(({ formProps = {}, listProps = {}, slug })=>{
    const { pluginUpdateStore } = useStores();
    const { busy, pluginUpdates, pluginUpdateFetchErrors } = pluginUpdateStore;
    const pluginUpdate = pluginUpdates.get(slug);
    const showHeadline = pluginUpdate?.unlicensedEntries.length > 0 && pluginUpdate?.licensedEntries.length > 0;
    useEffect(()=>{
        try {
            pluginUpdateStore.fetchPluginUpdate(slug);
        } catch (e) {
        // Silence is golden.
        }
    }, [
        slug
    ]);
    return pluginUpdateFetchErrors.get(slug) ? /*#__PURE__*/ _jsx(PluginUpdateErrorNotice, {
        slug: slug
    }) : busy || !pluginUpdate ? /*#__PURE__*/ _jsx(Spin, {
        spinning: true
    }) : /*#__PURE__*/ _jsxs("div", {
        children: [
            showHeadline && /*#__PURE__*/ _jsx(Divider, {
                type: "horizontal",
                orientation: "left",
                style: {
                    marginTop: 0
                },
                children: __("Not yet licensed")
            }),
            /*#__PURE__*/ _jsx(PluginUpdateForm, {
                ...formProps,
                pluginUpdate: pluginUpdate
            }),
            showHeadline && /*#__PURE__*/ _jsx(Divider, {
                type: "horizontal",
                orientation: "left",
                children: __("Already licensed")
            }),
            pluginUpdate.licensedEntries.length > 0 && /*#__PURE__*/ _jsx(PluginUpdateLicenseList, {
                ...listProps,
                pluginUpdate: pluginUpdate
            })
        ]
    });
});
export { PluginUpdateErrorNotice, PluginUpdateEmbed };
